const Probleme = () => {
  const problemes = [
    {
      icon: '⏰',
      title: 'Gestion manuelle obsolète',
      description: 'Processus manuels, papiers et tickets physiques créant des inefficacités et des erreurs.'
    },
    {
      icon: '💰',
      title: 'Perte de revenus',
      description: 'Difficulté à optimiser les tarifs et absence de données en temps réel pour maximiser l\'occupation.'
    },
    {
      icon: '🚗',
      title: 'Expérience utilisateur médiocre',
      description: 'Les citoyens perdent du temps à chercher des places et à gérer les paiements en espèces.'
    },
    {
      icon: '📊',
      title: 'Manque de visibilité',
      description: 'Absence de données centralisées et difficulté à analyser les tendances pour prendre des décisions éclairées.'
    }
  ];

  return (
    <section id="probleme" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Le défi actuel
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            La gestion du stationnement en Tunisie fait face à des défis majeurs qui freinent 
            le développement urbain et l'expérience des citoyens.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {problemes.map((probleme, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-red-50 to-orange-50 rounded-xl p-6 border border-red-100 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="text-4xl mb-4">{probleme.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {probleme.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {probleme.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-red-100 to-orange-100 rounded-xl p-6 border-l-4 border-red-500">
          <div className="flex items-start">
            <div className="text-3xl mr-3">⚠️</div>
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Un enjeu national
              </h3>
              <p className="text-base text-gray-700">
                Dans le cadre de la vision <strong>nextTunisia Horizon 2030</strong>, la digitalisation 
                des services publics est essentielle. Le stationnement doit être modernisé pour répondre 
                aux attentes des citoyens.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Probleme;

